import { Star } from "lucide-react";

export const SocialProof = () => {
  const testimonials = [
    { name: "Emma's Mum", text: "My daughter talked to Santa for 30 minutes! Magic! ✨" },
    { name: "Jack's Dad", text: "So realistic! Jack truly believed he was chatting with the real Santa." },
    { name: "Sophie's Gran", text: "Best £2 I ever spent. Pure Christmas joy!" },
  ];

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-gold text-gold" />
          ))}
        </div>
        <span className="text-muted-foreground text-xs sm:text-sm">Loved by thousands of families</span>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className="p-3 sm:p-4 rounded-xl bg-card/25 backdrop-blur-xl border border-border/30"
          >
            <p className="text-foreground text-xs sm:text-sm italic mb-1.5 sm:mb-2">"{testimonial.text}"</p>
            <p className="text-[10px] sm:text-xs text-muted-foreground">— {testimonial.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
